import React from 'react';
import EditBlog from './EditBlog';

const EditBlogModal = (props) => {
    return (
        <div>
            <div
                className="modal fade my-5"
                id="editModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 fw-bold" id="exampleModalLabel">
                                Update your Pitch
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <EditBlog editId={props.editId} />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditBlogModal;
